"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBestAggregator = void 0;
const contracts_1 = require("@shapeshiftoss/contracts");
const monads_1 = require("@sniptt/monads");
const assert_1 = __importDefault(require("assert"));
const viem_1 = require("viem");
const types_1 = require("../../../types");
const utils_1 = require("../../../utils");
const longTailHelpers_1 = require("./longTailHelpers");
const getBestAggregator = async (buyAsset, sellToken, buyToken, sellAmountIncludingProtocolFeesCryptoBaseUnit) => {
    const publicClient = contracts_1.viemClientByChainId[buyAsset.chainId];
    (0, assert_1.default)(publicClient !== undefined, `no public client found for chainId '${buyAsset.chainId}'`);
    const poolAddresses = (0, longTailHelpers_1.generateV3PoolAddressesAcrossFeeRange)(contracts_1.UNISWAP_V3_POOL_FACTORY_CONTRACT_MAINNET, sellToken, buyToken);
    const poolContractData = (0, longTailHelpers_1.getContractDataByPool)(poolAddresses, publicClient, sellToken.address, buyToken.address);
    const quoterContract = (0, viem_1.getContract)({
        abi: contracts_1.UNISWAP_V3_QUOTER_ABI,
        address: contracts_1.UNISWAP_V3_QUOTER_CONTRACT_MAINNET,
        client: publicClient,
    });
    const quotedAmountOutByPool = await (0, longTailHelpers_1.getQuotedAmountOutByPool)(poolContractData, BigInt(sellAmountIncludingProtocolFeesCryptoBaseUnit), quoterContract);
    const [bestPool, quotedAmountOut] = (0, longTailHelpers_1.selectBestRate)(quotedAmountOutByPool);
    const bestContractData = bestPool ? poolContractData.get(bestPool) : undefined;
    const bestAggregator = bestContractData ? longTailHelpers_1.feeAmountToContractMap[bestContractData.fee] : undefined;
    if (!bestAggregator || !quotedAmountOut) {
        return (0, monads_1.Err)((0, utils_1.makeSwapErrorRight)({
            message: `[getThorTradeQuote] - No best aggregator contract found.`,
            code: types_1.TradeQuoteError.UnsupportedTradePair,
        }));
    }
    return (0, monads_1.Ok)({ bestAggregator, quotedAmountOut });
};
exports.getBestAggregator = getBestAggregator;
